import { useHistory } from 'react-router-dom'

export const useFormAppearance = () => {
  const history = useHistory()
  const isPreview = history.location.pathname.includes('/r/preview')
  const isPatientForm = history.location.pathname.includes('/f/')
  const isKioskMode = history.location.pathname.includes('/k/')
  const isForm = history.location.pathname.includes('/r/')
  const isPacket = history.location.pathname.includes('/t/p/')

  const hasQuestionColor =
    isPreview || isPatientForm || isForm || isPacket || isKioskMode

  return { hasQuestionColor }
}
